import { createFileRoute } from "@tanstack/react-router";

import { InvestorConnectRouteComponent } from "@/route-components/InvestorConnectRouteComponent";

export const Route = createFileRoute("/_public/investor-connect")({
  validateSearch: (search: Record<string, unknown>) => ({
    investor_connect_requests_id:
      typeof search.investor_connect_requests_id === "string" ? search.investor_connect_requests_id : undefined,
  }),
  component: InvestorConnectRouteComponent,
});
